import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';

interface RespuestaEstudiante {
  id_evaluacion: number;
  id_rol_usuario: number;
  pregunta_1: string;
  pregunta_2: string;
  pregunta_3: string;
  pregunta_4: string;
  pregunta_5: string;
  pregunta_6: string;
  pregunta_7: string;
  pregunta_8: string;
  pregunta_9: string;
  pregunta_10: string;
  pregunta_11: string;
  pregunta_12: string;
  pregunta_13: string;
  pregunta_14: string;
  pregunta_15: string;
  pregunta_16: string;
  pregunta_17: string;
  pregunta_18: string;
  pregunta_19: string;
  pregunta_20: string;
  pregunta_21: string;
  pregunta_22: string;
  pregunta_23: string;
  pregunta_24: string;
  pregunta_25: string;
}
@Component({
  selector: 'app-subida-evaluaciones',
  standalone: true,
  imports: [],
  templateUrl: './subida-evaluaciones.component.html',
  styleUrl: './subida-evaluaciones.component.css',
})
export class SubidaEvaluacionesComponent {
  archivoSeleccionado: File | null = null;
  mensaje: string = '';
  cargando: boolean = false;

  constructor(private http: HttpClient, private router: Router) {}

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.archivoSeleccionado = file;
      this.mensaje = 'Archivo seleccionado: ' + file.name;
    }
  }

  cargarResultados(): void {
    if (!this.archivoSeleccionado) {
      this.mensaje = 'Por favor, selecciona un archivo Excel.';
      return;
    }

    this.cargando = true;
    this.mensaje = 'Procesando archivo...';

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const datos = XLSX.utils.sheet_to_json(
        worksheet
      ) as RespuestaEstudiante[];

      // Validar el formato del archivo
      if (
        !datos.every(
          (r) => r.id_evaluacion !== undefined && r.id_rol_usuario !== undefined
        )
      ) {
        this.mensaje = 'El archivo no tiene el formato correcto.';
        this.cargando = false;
        return;
      }

      // Obtener las respuestas correctas de la evaluación
      const idEvaluacion = datos[0].id_evaluacion; // Asumimos que todas las filas son de la misma evaluación
      this.obtenerRespuestasCorrectas(idEvaluacion, datos);
    };

    reader.readAsArrayBuffer(this.archivoSeleccionado);
  }

  obtenerRespuestasCorrectas(
    idEvaluacion: number,
    datos: RespuestaEstudiante[]
  ): void {
    this.http
      .get<any>(`${environment.apiUrl}/evaluacion/${idEvaluacion}`)
      .subscribe({
        next: (evaluacion) => {
          const respuestasCorrectas =
            this.extraerRespuestasCorrectas(evaluacion);
          this.procesarRespuestas(datos, respuestasCorrectas);
        },
        error: (error) => {
          this.mensaje =
            'Error al obtener las respuestas correctas: ' + error.message;
          this.cargando = false;
        },
      });
  }

  extraerRespuestasCorrectas(evaluacion: any): string[] {
    return evaluacion.preguntas.map((pregunta: any) => {
      const alternativaCorrecta = pregunta.alternativas.find(
        (a: any) => a.correcta
      );
      return alternativaCorrecta ? alternativaCorrecta.letra : null; // A, B, C o D
    });
  }

  procesarRespuestas(
    datos: RespuestaEstudiante[],
    respuestasCorrectas: string[]
  ): void {
    const resultados = datos.map((fila) => {
      const respuestasEstudiante = this.extraerRespuestasEstudiante(fila);
      const calificacion = this.calcularCalificacion(
        respuestasEstudiante,
        respuestasCorrectas
      );
      const nivelAlcanzado = this.calcularNivel(calificacion);

      return {
        id_evaluacion: fila.id_evaluacion,
        id_rol_usuario: fila.id_rol_usuario,
        calificacion,
        nivel_alcanzado: nivelAlcanzado,
      };
    });

    this.enviarResultados(resultados);
  }

  extraerRespuestasEstudiante(fila: RespuestaEstudiante): string[] {
    const respuestas: string[] = [];
    for (let i = 1; i <= 25; i++) {
      respuestas.push(
        fila[`pregunta_${i}` as keyof RespuestaEstudiante] as string
      );
    }
    return respuestas;
  }

  calcularCalificacion(
    respuestasEstudiante: string[],
    respuestasCorrectas: string[]
  ): number {
    return respuestasEstudiante.reduce((calificacion, respuesta, index) => {
      return calificacion + (respuesta === respuestasCorrectas[index] ? 1 : 0);
    }, 0);
  }

  calcularNivel(puntuacion: number): string {
    if (puntuacion < 11) return 'INICIO';
    if (puntuacion >= 11 && puntuacion < 16) return 'EN PROCESO';
    if (puntuacion >= 16 && puntuacion < 21) return 'LOGRO';
    return 'LOGRO DESTACADO';
  }

  enviarResultados(resultados: any[]): void {
    let completados = 0;
    let errores = 0;

    resultados.forEach((resultado) => {
      this.http
        .post(`${environment.apiUrl}/resultado-evaluacion`, resultado)
        .subscribe({
          next: () => {
            completados++;
            this.actualizarProgreso(completados, errores, resultados.length);
          },
          error: () => {
            errores++;
            this.actualizarProgreso(completados, errores, resultados.length);
          },
        });
    });
  }

  actualizarProgreso(
    completados: number,
    errores: number,
    total: number
  ): void {
    this.mensaje = `Procesando... ${
      completados + errores
    }/${total} (Éxitos: ${completados}, Errores: ${errores})`;

    if (completados + errores === total) {
      this.cargando = false;
      this.mensaje = `Proceso completado. Éxitos: ${completados}, Errores: ${errores}`;
      this.archivoSeleccionado = null;
    }
  }

  volver() {
    this.router.navigate(['/historial-evaluacion']);
  }
}
